import Clear from "@mui/icons-material/Clear";
import { Paper } from "@mui/material";

type ClearSelectButtonProps = {
  onClick: () => void;
};

const ClearSelectButton = ({ onClick }: ClearSelectButtonProps) => {
  return (
    <Paper
      sx={{
        display: "flex",
        justifyContent: "center",
        height: "100%",
        alignItems: "center",
        flex: 1,
        minWidth: 40,
        p: 0.5,
        "&:hover": {
          cursor: "pointer",
          borderColor: "primary.main",
        },
      }}
      variant="outlined"
      onClick={onClick}
    >
      <Clear fontSize="small" />
    </Paper>
  );
};

export default ClearSelectButton;
